import { render, staticRenderFns } from "./MasterBranchSummary.vue?vue&type=template&id=5a73dd06&scoped=true"
import script from "./MasterBranchSummary.vue?vue&type=script&lang=js"
export * from "./MasterBranchSummary.vue?vue&type=script&lang=js"
import style0 from "./MasterBranchSummary.vue?vue&type=style&index=0&id=5a73dd06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a73dd06",
  null
  
)

export default component.exports